export const s3Config = (type) => ({
    dirName         : "pimptup/" + type,
    bucketName      : 'pimpt-up',
    region          : 'eu-north-1',
    accessKeyId     : 'AKIAUQDUW4FDZGC2WLVP',
    secretAccessKey : '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',
});